module.exports = __webpack_public_path__ + "img/en2.e68f87e8.png";